<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext"> {{ templateId ? '修改运费模版' : '添加运费模版' }} </div>
        <div class="addpoper" @click="baochun">
            <div> <el-icon :size="24" color="#fff">
                    <Plus style=" margin-right: 8px" />
                </el-icon></div>
            <div style="height: 24px;">保存模版</div>
        </div>
    </div>
    <div class="viplist">
        <div class="yunfei">
            模版名称: &nbsp;&nbsp;&nbsp;<input type="text" v-model="template.templateName"
                placeholder="请输入名称，最多30个字（60个字符）">

        </div>
        <div class="shoufei">
            <div>
                收费方式: &nbsp;&nbsp;&nbsp;
            </div>
            <div>
                <input type="radio" id="jian" name="jian" value="0" v-model="template.chargingId" />

                <label for="jian">&nbsp;&nbsp;按件计费</label> <br>
                <input type="radio" id="zhong" name="jian" value="1" v-model="template.chargingId"
                    style=" margin-top: 19px;" />
                <label for="zhong">&nbsp;&nbsp;按重量计费</label>
            </div>

        </div>
        <div class="quyu">
            <div>运费设置: &nbsp;&nbsp;&nbsp;不限制区域:</div>
            <div class="quyuse">
                <div class="baoyou">
                    <div class="bubao">
                        <input type="radio" id="bubao1" name="bubao" :value="false"
                            v-model="template.noRestrictedArea[0].isParcel" />
                        &nbsp;&nbsp; <label for="bubao1">不包邮</label>
                        <div class="jiannum">
                            <table>
                                <thead>
                                    <tr>
                                        <th>初始件（件）</th>
                                        <th>初始运费（元）</th>
                                        <th>续件数量（件）</th>
                                        <th>续件费用（件）</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].noParcel[0]"
                                                class="mx-4" :min="1" :max="999" placeholder="1件起步"
                                                controls-position="right" />
                                        </td>

                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].noParcel[1]"
                                                class="mx-4" :min="0" :max="999" placeholder="请填写"
                                                controls-position="right" />
                                        </td>

                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].noParcel[2]"
                                                class="mx-4" :min="1" :max="999" placeholder="1件起步"
                                                controls-position="right" />
                                        </td>

                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].noParcel[3]"
                                                class="mx-4" :min="0" :max="999" placeholder="1件起步"
                                                controls-position="right" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="bao">
                        <input type="radio" id="bubao2" name="bubao" :value="true"
                            v-model="template.noRestrictedArea[0].isParcel" />
                        &nbsp;&nbsp; <label for="bubao2">条件包邮</label>
                        <div class="jiannum">
                            <table>
                                <thead>
                                    <tr>
                                        <th>按金额包邮</th>
                                        <th>初按件包邮</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].parcel[0]"
                                                class="mx-4" :min="0" :max="999" placeholder="请填写"
                                                controls-position="right" />
                                        </td>

                                        <td>
                                            <el-input-number v-model="template.noRestrictedArea[0].parcel[1]"
                                                class="mx-4" :min="1" :max="999" placeholder="1件起步"
                                                controls-position="right" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="quyufrom" style="margin-top: 10px;" v-for="(item, index) in template.isRestrictedArea"
                :key='index'>
                <div class="quyutianjia">
                    <div>指定区域:
                        <el-cascader :options="area" v-model="item.Name" :props="props"
                            @change="quyuchange($event, index)" collapse-tags collapse-tags-tooltip clearable
                            :placeholder="item.regionNames" style="width: 270px;" />
                        <!-- <select @change="selectClass($event, index)">
                            <option value="NONE" v-if="templateId && item.regionName">{{ item.regionName[0] }}</option>

                            <option value="NONE">未选择</option>

                            <option v-for="(item2, id) in area" :key="id" :value="item2.areaId">
                                {{ item2.value }}
                            </option>
                        </select> -->

                    </div>
                    <div class="tianjiaright">
                        <div style="margin-right: 32px; cursor: pointer;"
                            v-if="index == template.isRestrictedArea.length - 1" @click="addquyu">添加区域</div>
                        <div style="cursor: pointer;" v-if="index != 0" @click="removequyun(index, item.id)">删除区域</div>
                    </div>
                </div>

                <div class="quyuse">
                    <div class="baoyou">
                        <div class="bubao">
                            <input type="radio" :id="'sbubao' + index" :name="'zhiding' + index" :value="false"
                                v-model="item.isParcel" v-if="!templateId || item.isnew" />
                            &nbsp;&nbsp;<label :for="'sbubao' + index">不包邮</label>
                            <div class="jiannum">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>初始件（件）</th>
                                            <th>初始运费（元）</th>
                                            <th>续件数量（件）</th>
                                            <th>续件费用（件）</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <el-input-number v-model="item.noParcel[0]" class="mx-4" :min="1"
                                                    :max="999" placeholder="1件起步" controls-position="right" />
                                            </td>

                                            <td>
                                                <el-input-number v-model="item.noParcel[1]" class="mx-4" :min="0"
                                                    :max="999" placeholder="请填写" controls-position="right" />
                                            </td>

                                            <td>
                                                <el-input-number v-model="item.noParcel[2]" class="mx-4" :min="1"
                                                    :max="999" placeholder="1件起步" controls-position="right" />
                                            </td>

                                            <td>
                                                <el-input-number v-model="item.noParcel[3]" class="mx-4" :min="0"
                                                    :max="999" placeholder="1件起步" controls-position="right" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="bao">
                            <input type="radio" :id="'zbubao' + index" :name="'zhiding' + index" :value="true"
                                v-model="item.isParcel" v-if="!templateId || item.isnew" />
                            &nbsp;&nbsp;<label :for="'zbubao' + index">条件包邮</label>
                            <div class="jiannum">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>按金额包邮</th>
                                            <th>初按件包邮</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>

                                                <el-input-number v-model="item.parcel[0]" class="mx-4" :min="0"
                                                    :max="999" placeholder="1件起步" controls-position="right" />
                                            </td>

                                            <td>
                                                <el-input-number v-model="item.parcel[1]" class="mx-4" :min="1"
                                                    :max="999" placeholder="请填写" controls-position="right" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import api from '@/api/api';
import { onMounted, reactive, ref, getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router';
const instance = getCurrentInstance();
const props = { multiple: true }
const route = useRoute()
const templateId = route.query.templateId
let areaId = []
let areaId2 = []
let areaIdDelete = []

let template = reactive({
    "chargingId": 0,
    "isRestrictedArea": [
        {
            "isParcel": true,
            "noParcel": [1, 0, 1, 0],
            "parcel": [0, 1],
            "regionId": [],
            "regionName": [],
            "Name": [],
        }
    ],
    "noRestrictedArea": [
        {
            "isParcel": true,
            "noParcel": [1, 0, 1, 0],
            "parcel": [0, 1],

        }
    ],
    "region": [0],
    "storeId": 77,

    "templateName": ""
})
onMounted(() => {
    console.log('route', route.query.templateId)
    if (templateId) {
        console.log('修改', templateId)
        freightTemplateInfo()
    }
    areaList()
})
const quyuchange = (e, index) => {
    let areaNames = []
    console.log(e, index)
    for (let a = 0; a < area.value.length; a++) {
        for (let b = 0; b < e.length; b++) {
            if (e[b][0] == area.value[a].areaCode) {
                areaNames.push(area.value[a].label)
            }
        }
    }
    let a = [...new Set(areaNames)];
    console.log(a)
    let b = []
    for (let a = 0; a < e.length; a++) {
        b.push(e[a][e[a].length - 1])
    }
    console.log(b)
    template.isRestrictedArea[index].regionId = b
    template.isRestrictedArea[index].regionName = a
    console.log(template.isRestrictedArea)


}

const freightTemplateInfo = async () => {

    const res = await api.freightTemplateInfo(templateId)


    template = deepClone(res.data)

    areaId = template.areaId
    if (template.isRestrictedArea.length < 1) {
        let fiveDigitNumber = Math.floor(Math.random() * 90000) + 10000;
        let data = {
            'id': fiveDigitNumber,
            'isnew': true,
            "isParcel": true,
            "noParcel": [1, 0, 1, 0],
            "parcel": [0, 1],
            "regionId": [],
            "regionName": [],
            "Name": [],
        }
        template.isRestrictedArea.push(data)
    } else {
        for (let a = 0; a < template.isRestrictedArea.length; a++) {
            template.isRestrictedArea[a].length = template.isRestrictedArea.length

            if (template.isRestrictedArea[a].regionName) {
                template.isRestrictedArea[a].regionNames = template.isRestrictedArea[a].regionName.join(',')
            }
        }

        if (!template.noRestrictedArea[0].parcel) {
            template.noRestrictedArea[0].parcel = []
        }
        if (!template.noRestrictedArea[0].noParcel) {
            template.noRestrictedArea[0].noParcel = []
        }
        for (let a = 0; a < template.isRestrictedArea.length; a++) {
            if (!template.isRestrictedArea[a].noParcel) {
                template.isRestrictedArea[a].noParcel = []
            }
            if (!template.isRestrictedArea[a].parcel) {
                template.isRestrictedArea[a].parcel = []
            }
        }
    }

    console.log('freightTemplateInfo', template)


}
const area = ref(null)

const areaList = async () => {
    const res = await api.areaList()
    // let arae = updateArray(res.data)
    // console.log('areaList', arae)

    area.value = updateArray(res.data)
    console.log('areaList', area.value)

}
const updateArray = (array) => {
    let newArray = [];

    // 遍历原始数组中的每个对象
    for (let obj of array) {
        // 创建一个新的对象来存储修改后的属性值
        let newObj = {};

        // 如果对象有children属性，递归调用updateArray函数来处理children数组
        if (obj.children && obj.children.length > 0) {
            newObj.children = updateArray(obj.children);
        }

        // 将areaName改为value, areaId改为label
        newObj.value = obj.areaCode;
        newObj.label = obj.areaName;

        // 将原始对象的其他属性复制到新对象中
        for (let key in obj) {
            if (key !== 'areaName' && key !== 'areaId' && key !== 'children') {
                newObj[key] = obj[key];
            }
        }

        // 将处理后的对象添加到新数组中
        newArray.push(newObj);
    }

    return newArray;
}

const selectClass = (event, index) => {
    console.log(event.target.value, index)
    if (event.target.value != 'NONE') {
        const selectedAreaId = event.target.value;
        const selectedAreaName = area.value.find(item => item.value == selectedAreaId).label;
        console.log(selectedAreaId, selectedAreaName)
        template.isRestrictedArea[index].regionId.push(selectedAreaId)
        template.isRestrictedArea[index].regionName.push(selectedAreaName)
    }
}
const addquyu = () => {
    let fiveDigitNumber;

    do {
        fiveDigitNumber = Math.floor(Math.random() * 90000) + 10000;
    } while (template.isRestrictedArea.some(area => area.id === fiveDigitNumber));

    let data = {
        'id': fiveDigitNumber,
        'isnew': true,
        "isParcel": true,
        "noParcel": [1, 0, 1, 0],
        "parcel": [0, 1],
        "regionId": [],
        "regionName": [],
        "Name": [],
    }

    template.isRestrictedArea.push(data);
    console.log(template.isRestrictedArea);
    instance.proxy.$forceUpdate();
}
const removequyun = (index, id) => {

    // template.isRestrictedArea[index].regionName = []
    template.isRestrictedArea.splice(index, 1)
    areaIdDelete.push(id)
    // template.isRestrictedArea = []
    console.log(index, template.isRestrictedArea, areaIdDelete)
    instance.proxy.$forceUpdate();
}
const baochun = async () => {

    let templates = deepClone(template)
   
    if (templates.noRestrictedArea[0].isParcel) {
        templates.noRestrictedArea[0].noParcel = [0, 0, 0, 0]
        delete templates.noRestrictedArea[0].isParcel

    } else {
        templates.noRestrictedArea[0].parcel = [0, 0]
        delete templates.noRestrictedArea[0].isParcel

    }
    if (templates.isRestrictedArea.length > 0) {

templates.region.push(1);

} else {
delete templates.isRestrictedArea;
}
    if (templateId) {
        console.log(template)

        if (template.templateName == '') {
            ElMessage.error('请输入模板名称!')
        } else {
            templates.areaIdDelete = areaIdDelete
            templates.areaId2 = templates.isRestrictedArea.map(element => {
                return element.id;
            });
            for (let a = 0; a < templates.isRestrictedArea.length; a++) {
                delete templates.isRestrictedArea[a].Name
                delete templates.isRestrictedArea[a].isParcel
                if (templates.isRestrictedArea[a].regionNames) {
                    if (templates.isRestrictedArea[a].regionNames) {
                        delete templates.isRestrictedArea[a].regionNames;
                    }
                }

            }
            const res = await api.freightTemplateput(templates)

            console.log(res)
            if (res.success) {
                ElMessage({
                    message: '模板保存成功！',
                    type: 'success',
                })
            } else {
                ElMessage.error('模板保存失败' + res.message)

            }
        }

    } else {
        console.log(template)

        if (template.templateName == '') {
            ElMessage.error('请输入模板名称!')
        } else {
            for (let index = 0; index < templates.isRestrictedArea.length; index++) {
                delete templates.isRestrictedArea[index].Name
                if (templates.isRestrictedArea[index].isParcel) {
                    templates.isRestrictedArea[index].noParcel = [0, 0, 0, 0]
                    delete templates.isRestrictedArea[index].isParcel
                } else {
                    templates.isRestrictedArea[index].parcel = [0, 0]
                    delete templates.isRestrictedArea[index].isParcel
                }
                if (templates.isRestrictedArea[index].regionId.length < 1) {
                    templates.isRestrictedArea.splice(index, 1)
                }

            }

            console.log('templates', templates)
            const res = await api.freightTemplate(templates)
            console.log(res)
            if (res.success) {
                ElMessage({
                    message: '模板保存成功！',
                    type: 'success',
                })
            } else {
                ElMessage.error('模板保存失败' + res.message)

            }

        }
    }

}
function deepClone(obj) {
    //判断 传入对象 为 数组 或者 对象
    var result = Array.isArray(obj) ? [] : {};
    // for in 遍历
    for (var key in obj) {
        // 判断 是否 为自身 的属性值（排除原型链干扰）
        if (obj.hasOwnProperty(key)) {
            // 判断 对象的属性值 中 存储的 数据类型 是否为对象
            if (typeof obj[key] === 'object') {
                // 有可能等于 null
                if (obj[key] === null) {
                    result[key] = null
                    continue
                }
                // 递归调用
                result[key] = deepClone(obj[key]);   //递归复制
            }
            // 不是的话 直接 赋值 copy
            else {
                result[key] = obj[key];
            }
        }
    }
    // 返回 新的对象
    return result;
}
const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
    height: 20px;
}
table {
    border-collapse: collapse;
}

select {
    width: 166px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;

    option {
        font-size: 14px;
        //    line-height: 20px;
    }
}

::v-deep .mx-4 {
    width: 98px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    margin: 0 auto;

    .el-input__wrapper {
        font-size: 11px;
    }

    .el-input-number__decrease {
        border-color: transparent !important;
        background-color: transparent;
    }

    .el-input-number__increase {
        border-color: transparent !important;
        background-color: transparent;
    }
}



.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
}


.viplist {
    position: relative;
    margin-top: 25px;
    min-height: calc(100% - 85px);
    min-width: 1166px;
    // min-height: 662px;
    background: #FFFFFF;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 25px 0 0 30px;

    font-size: 14px;
    font-weight: 400;
    color: #666666;

    .yunfei {


        input {
            outline: none;
            border: 1px solid #D9D9D9;
            width: 762px;
            height: 32px;
            padding-left: 12px;
        }

    }

    .shoufei {
        margin-top: 34px;
        display: flex;

        input {
            width: 19px;
            height: 19px;
            background: #FFFFFF;
            border: 1px solid #707070;
        }
    }

    .quyu {
        margin-top: 28px;

        .quyutianjia {
            margin-left: 80px;
            width: 766px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .tianjiaright {
                display: flex;
                font-weight: 400;
                font-size: 12px;
                color: #1890FF;
            }
        }

        .quyuse {
            margin-top: 11px;
            margin-left: 80px;

            input {
                width: 19px;
                height: 19px;
                background: #FFFFFF;
                border: 1px solid #707070;
            }


            .baoyou {
                padding: 19px 0 0 20px;
                width: 766px;
                height: 202px;
                background: #f7f7f7;
                border: 1px solid rgba(112, 112, 112, 0.1);
                display: flex;

                .bubao {
                    .jiannum {
                        margin-top: 13px;
                        width: 458px;
                        height: 125px;
                        background: rgba(44, 44, 44, 0.03);
                        border: 1px solid rgba(112, 112, 112, 0.1);

                        table {
                            width: 100%;

                            thead {

                                tr {

                                    th {

                                        width: 110px;
                                        height: 50px;
                                        line-height: 50px;
                                        border-bottom: 1px solid #707070;


                                    }
                                }
                            }

                            tbody {
                                tr {
                                    height: 50px;

                                    td {

                                        width: 110px;
                                        padding-top: 20px;
                                        box-sizing: border-box;
                                        text-align: center;


                                        .mx-4 {
                                            width: 90%;
                                            margin: 0 auto;
                                            display: inline-block;
                                        }
                                    }

                                }

                            }

                        }
                    }
                }

                .bao {
                    margin-left: 30px;

                    .jiannum {
                        margin-top: 13px;
                        width: 236px;
                        height: 125px;
                        background: rgba(44, 44, 44, 0.03);
                        border: 1px solid rgba(112, 112, 112, 0.1);

                        table {
                            width: 100%;

                            thead {

                                tr {

                                    th {

                                        width: 110px;
                                        height: 50px;
                                        line-height: 50px;
                                        border-bottom: 1px solid #707070;


                                    }
                                }
                            }

                            tbody {
                                tr {
                                    height: 50px;

                                    td {

                                        width: 110px;
                                        padding-top: 20px;
                                        box-sizing: border-box;
                                        text-align: center;


                                        .mx-4 {
                                            width: 90%;
                                            margin: 0 auto;
                                            display: inline-block;
                                        }
                                    }

                                }

                            }

                        }

                    }
                }
            }
        }
    }




}
</style>